( function ( _s ) {
	/**
	 * from: https://stackoverflow.com/questions/10787782/full-height-of-a-html-element-div-including-border-padding-and-margin
	 * @param {*} el
	 * @return
	 */
	const getAbsoluteHeight = el => {
		const styles = window.getComputedStyle( el );
		const margin = parseFloat( styles.marginTop ) + parseFloat( styles.marginBottom );
		return Math.ceil( el.offsetHeight + margin );
	};

	/**
	 * from: https://stackoverflow.com/questions/9333379/check-if-an-elements-content-is-overflowing
	 * @param {*} element
	 * @return
	 */
	function isOverflown( element ) {
		return (
			element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth
		);
	}

	/**
	 * Get Style property value
	 *
	 * @param {*} el
	 * @param {*} styleProp
	 * @returns
	 */
	function getStyle( el, styleProp ) {
		var x = el;
		if ( x.currentStyle ) var y = x.currentStyle[ styleProp ];
		else if ( window.getComputedStyle )
			var y = document.defaultView.getComputedStyle( x, null ).getPropertyValue( styleProp );
		return y;
	}

	/**
	 * Loads the shave library asyncly and calls the indicated callback, if
	 * the library is already loaded (object exists on window) then we just execute the callback
	 *
	 * @param {Function} callback
	 */
	const loadShaveLib = callback => {
		if ( typeof window.shave === 'function' ) {
			callback();
		} else {
			window
				.fetchInject( [
					'https://cdnjs.cloudflare.com/ajax/libs/shave/5.0.4/shave.min.js',
				] )
				.then( () => {
					callback();
				} );
		}
	};

	const initializeTruncationEv = _textWrap => {
		const _title = _textWrap.find( '.card-title' );
		const _desc = _textWrap.find( '.card-description' );
		const originalTitle = _title.length ? _title.el[ 0 ].textContent : '';
		const originalDesc = _desc.length ? _desc.el[ 0 ].textContent : '';

		//window event when resized
		_s( window ).on(
			'resize',
			window.debounce( () => {
				//set original text
				if ( _title.length ) {
					_title.el[ 0 ].textContent = originalTitle;
				}
				if ( _desc.length ) {
					_desc.el[ 0 ].textContent = originalDesc;
				}
				//then do truncate again
				truncateText( _title, _desc, _textWrap );
			}, 300 )
		);

		//truncate on page load
		truncateText( _title, _desc, _textWrap );
	};

	/**
	 *
	 * @param {*} _title
	 * @param {*} _desc
	 * @param {*} _textWrap
	 *
	 */
	const truncateText = ( _title, _desc, _textWrap ) => {
		const titleHeight = _title.length ? getAbsoluteHeight( _title.el[ 0 ] ) : 0;
		const descHeight = _desc.length ? getAbsoluteHeight( _desc.el[ 0 ] ) : 0;

		if ( titleHeight > 0 && isOverflown( _title.el[ 0 ] ) ) {
			window.shave( _title.el[ 0 ], titleHeight );
		}

		if ( descHeight > 0 && isOverflown( _desc.el[ 0 ] ) ) {
			const lineHeightVal = parseFloat( getStyle( _desc.el[ 0 ], 'line-height' ) );
			const howManyLines = Math.floor( descHeight / lineHeightVal );
			window.shave( _desc.el[ 0 ], howManyLines * lineHeightVal );
		}
	};

	/**
	 * Shave a single element's text to FILL its rendered height. Used by bespoke
	 * cards via a `data-shave-fill` hook — decoupled from the generic `.card-*`
	 * classes so none of their styling bleeds in. The element must have a bounded
	 * height (flex:1 + overflow:hidden) so it fills the available space; shave then
	 * trims the text to a word boundary + ellipsis. Re-runs on resize.
	 *
	 * @param {Element} node
	 */
	const shaveFillEl = node => {
		if ( ! node ) return;

		const doFill = () => {
			//the box is flex:1 + overflow:hidden, so clientHeight is the available
			//space (content-independent); shave trims the text (scrollHeight) to fit it.
			const maxH = node.clientHeight;
			if ( maxH > 0 ) {
				window.shave( node, maxH );
			}
		};

		_s( window ).on( 'resize', window.debounce( doFill, 300 ) );
		doFill();
	};

	_s.fn.cardInit = function () {
		return this.each( el => {
			const _self = _s( el );
			if ( ! _self.hasClass( 'is--initialized' ) ) {
				//generic card truncation (.text-container > .card-title/.card-description)
				initializeTruncationEv( _self.find( '.text-container' ) );
				//bespoke cards: fill-and-shave any [data-shave-fill] element
				_self.find( '[data-shave-fill]' ).each( node => shaveFillEl( node ) );
				//add class for initialized node
				_self.addClass( 'is--initialized' );
			}
		} );
	};

	/* When we call the event, we load the shave library and then trigger the callback indicated */
	_s( window ).on( 'fr:initialize-shave', e => {
		loadShaveLib( e.detail.callback );
	} );

	_s( document ).ready( () => {
		const _els = _s( '.card' );

		if ( _els.el.length ) {
			_s( window ).trigger( 'fr:initialize-shave', {
				callback: () => {
					_els.cardInit();
				},
			} );
		}
	} );
} )( window._s );
